import { cloneDeep } from "lodash";
import reduxStore from "../../../configureEnvStore";
import { ENABLED, TRACK_SUBSCRIBE_FOR } from "../../../constants/Constants";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import {
    setActiveuserlist,
    setIsRemoteParticipantJoined,
    setIsRoomConnected,
    setNewActiveUserlist,
    setOwnIndex,
    setParticipantCount,
    setPartiCountForDisplay,
    setTotalUserCount,
} from "../../../reducers/common-reducer";
import { handleCallPartcipantArrayOnJoin } from "../../../shared/dataTrackFunction";
import { isSilentObserverAvailable } from "../../../shared/function";
import { dualStreamEnabled, isSilentObserver, showMeVideoEnabled, singleUserEnabled } from "../../../shared/utility";
import { manageShowMeMicrophone, videoOnCallJoinFeature } from "../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import livePointerService from "../../LivePointer/livePointerService";
import { setLivePointerColorsForAllUser } from "../../LivePointer/LivePointerUtils";
import { getUserDetailsById, initializeRemoteParticipantDeviceInfo, updateParticipantCountForDisplay } from "../Room/roomFunction";
import { LogFirebase } from "../../../services/firestore";
import { handleTrackSubscriptionFailed } from "../Events/RoomEventsFunction/TrackSubscriptionFailed/handleTrackSubscriptionFailed";
import { setParticipantNetworkQuality } from "./setRemoteParticipantNetworkquality";
import { showSilentObserverInParticipantList } from "../../SilentObserver/SilentObserverUtils";
import CallStatsService from "../../../services/callStatsService";
import { registerVideoRoomMonitor } from "../twilioCallUtility";
import { updateOrAddParticipant } from "../videoScreenShareOverrideFunction";
import { checkNetworkType } from "../../Network/NetworkUtils";
import { setSilentObserverConnect } from "../../../reducers/silentObserver-reducer";

export const setActiveRoom = (room) => {
    registerVideoRoomMonitor(room);
    document.getElementById("call-action-menu")?.classList?.add("active");
    reduxStore.dispatch(setIsRoomConnected(true));
    const { partiCountForDisplay, activeuserlist } = reduxStore.getState().commonReducer;
    reduxStore.dispatch(setPartiCountForDisplay(parseInt(partiCountForDisplay) + 1));
    checkNetworkType();
    handleCallPartcipantArrayOnJoin();
    if (isSilentObserver(room.localParticipant.identity)) {
        CALL_DATA.isObserver = true;
        reduxStore.dispatch(setSilentObserverConnect(true));
    } else {
        CALL_DATA.isObserver = false;
    }
    if (dualStreamEnabled()) {
        // for silent observer in grid view not shows her/his view
        if (isSilentObserver(room.localParticipant.identity)) {
            console.log("addViewInGrid");
        } else {
            const participantDetails = {
                identity: room.localParticipant.identity,
                isVideoStreaming: false, // or false
                isScreenShareStreaming: false,
                device_type: GLOBAL_MEETING_DATA.device_type || null,
            };
            console.log("setGalleryViewConnectedUser_setActive_Func", participantDetails);

            // Call the function to update or add the participant
            updateOrAddParticipant(participantDetails);
        }
    }

    if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
        setLivePointerColorsForAllUser(room.localParticipant.identity);
    }
    if (singleUserEnabled()) {
        reduxStore.dispatch(setIsRemoteParticipantJoined(true));
        // Publish video on join call for single guest user allow call
        if (!isSilentObserverAvailable()) {
            manageShowMeMicrophone();
        }
    }

    if (room.participants.size == 0) {
        // for 1st user only who is join the call
        let activeUser = cloneDeep(activeuserlist);
        activeUser[room.localParticipant.identity] = 1;
        reduxStore.dispatch(setOwnIndex(1)); // set own index variable (same as old portal) for 1st user only who is join the call
        reduxStore.dispatch(setTotalUserCount(1)); // set total user count variable (same as old portal) for 1st user only who is join the call
        reduxStore.dispatch(setActiveuserlist(activeUser)); // set active user list variable (same as old portal) for 1st user only who is join the call
        reduxStore.dispatch(setNewActiveUserlist(activeUser)); // set new active user list variable (same as old portal) for 1st user only who is join the call
        const participantCount = 1;
        reduxStore.dispatch(setParticipantCount(participantCount));
    }
    // Publish video on join call for single guest user allow call
    if (singleUserEnabled()) {
        if (room?.participants?.size + 1 > 0) {
            // if local joined and another user has already joined.
            console.error("::callstats from room join");
            CallStatsService.callStats(false);
        }
        if (showMeVideoEnabled()) {
            videoOnCallJoinFeature();
        }
    } else if (room?.participants?.size + 1 > 1) {
        // if local joined and another user has already joined.
        console.error("::callstats from room join");
        CallStatsService.callStats(false);
    }

    if (room.participants.size != 0 && !singleUserEnabled() && showMeVideoEnabled()) {
        console.log("videoOnCallJoinFeature___setActiveRoom", room.participants.size);
        videoOnCallJoinFeature();
    }

    for (const remoteParticipant of room.participants.values()) {
        initializeRemoteParticipantDeviceInfo(remoteParticipant.identity);
        reduxStore.dispatch(setParticipantCount(room.participants.size + 1));
        updateParticipantCountForDisplay(remoteParticipant.identity, "increment");
        // setTimeout(() => {
        if (dualStreamEnabled()) {
            // for the silent observer do not create grid view for other participants
            if (!isSilentObserver(remoteParticipant.identity)) {
                const participantDetails = {
                    identity: remoteParticipant.identity,
                    isVideoStreaming: false, // or false
                    isScreenShareStreaming: false,
                    device_type: getUserDetailsById(remoteParticipant.identity)?.device_type || null,
                };
                console.log("setGalleryViewConnectedUser_setActive_loop", participantDetails);
                // Call the function to update or add the participant
                updateOrAddParticipant(participantDetails, false, true); // false for not remove participant, true for add new participant
            }
        }
        // }, 100);

        // Add remote participant in a array and passed 'participantConnected' as strings only
        //// addCallParticipant(remoteParticipant, "participantConnected");
        setParticipantNetworkQuality(remoteParticipant);

        // Set participant color for live pointer
        if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
            setLivePointerColorsForAllUser(remoteParticipant.identity);
        }

        /* For silent observer identity show in Agent side */
        setTimeout(() => {
            showSilentObserverInParticipantList(remoteParticipant.identity);
        }, 3000);

        remoteParticipant.on("trackPublicationFailed", (error, track) => {
            LogFirebase("TwilioEvents", "trackPublicationFailedFromRemote", {
                track_details: track.kind,
                error_message: error.message,
            });
        });

        remoteParticipant.on("trackSubscriptionFailed", (error, track) => {
            handleTrackSubscriptionFailed(error, track, TRACK_SUBSCRIBE_FOR.REMOTE);
            LogFirebase("TwilioEvents", "trackSubscriptionFailedFromRemote", {
                track_details: track.kind,
                error_message: error.message,
            });
        });

        remoteParticipant.on("trackAdded", (track, participant) => {});
        remoteParticipant.on("trackSubscribed", (track, participant) => {});
    }
};
